import { FC, useState } from 'react';

import { LogoAvatarIcon } from '@/components/ui/Icons/Icons';

import { AvatarSize, getAvatarText } from './Avatar.helpers';
import * as S from './Avatar.styles';

interface AvatarProps {
  name?: string | null;
  image?: string | null;
  dataCy?: string;
  size: AvatarSize;
  showInitials?: boolean;
}

export const Avatar: FC<AvatarProps> = ({
  name,
  image,
  size,
  dataCy,
  showInitials = true
}) => {
  const [isError, setIsError] = useState(false);
  const showImage = !!image && !isError;
  const computedName = name ?? 'None';

  return (
    <S.AvatarWrapper data-cy={dataCy} $withImage={showImage} $size={size}>
      {showImage ? (
        <S.AvatarImage
          draggable={false}
          onError={() => setIsError(true)}
          src={image}
          alt={computedName}
          fill
        />
      ) : !showInitials && image === null ? (
        <LogoAvatarIcon />
      ) : (
        <S.AvatarName data-testid="avatar-name" htmlTag="h3" $size={size}>
          {getAvatarText(computedName)}
        </S.AvatarName>
      )}
    </S.AvatarWrapper>
  );
};
